export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_LIMIT = 10;
export const RESULTS_PER_PAGE = 10;
export const API_KEY = 'aba6ce5c-be11-4c26-bf1d-960fb7430656';
export const MODAL_CLOSE_SEC = 2.5;
export const SAFETY_WAIT = 1;